<template>
  <v-container
    id="Setting"
    fluid
    tag="section"
  >
    <div
      align="end"
    >
      <v-btn
        x-large
        elevation="10"
        tile
        depressed
        color="red"
        to="/"
      >
        Back To Main
      </v-btn>
    </div>
    <base-v-component
      heading="Setting"
      link="components/simple-tables"
    />
    <base-material-card
      icon="mdi-cog"
      title="Setting"
      class="px-10 py-3"
    >
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        class="ml-auto"
        label="Search"
        hide-details
        single-line
        style="max-width: 320px;"
      />
      <v-data-table
        :headers="headers"
        :items="desserts"
        :items-per-page="5"
        class="elevation-1"
        :loading="status.loading"
        :search="search"
      >
        <template
          v-slot:[`item.MaterialId`]="{ item }"
        >
          <v-simple-checkbox
            v-model="item.MaterialId"
          />
        </template>
        <template
          v-slot:[`item.OATMaterial`]="{ item }"
        >
          <v-simple-checkbox
            v-model="item.OATMaterial"
          />
        </template>
        <template
          v-slot:[`item.tb_cash`]="{ item }"
        >
          <v-simple-checkbox
            v-model="item.tb_cash"
          />
        </template>
        <template
          v-slot:[`item.CI`]="{ item }"
        >
          <v-simple-checkbox
            v-model="item.CI"
          />
        </template>
        <template
          v-slot:[`item.Account`]="{ item }"
        >
          <v-simple-checkbox
            v-model="item.Account"
          />
        </template>
        <template
          v-slot:[`item.Currency`]="{ item }"
        >
          <v-select
            v-model="item.Currency"
            :items="currency"
          />
        </template>
        <template
          v-slot:[`item.Blocked`]="{ item }"
        >
          <v-select
            v-model="item.Blocked"
            :items="blocked"
          />
        </template>
        <template
          v-slot:[`item.EPM`]="{ item }"
        >
          <v-select
            v-model="item.EPM"
            :items="blocked"
          />
        </template>
        <template
          v-slot:[`item.BrandL1`]="{ item }"
        >
          <v-simple-checkbox
            v-model="item.BrandL1"
          />
        </template>
        <template
          v-slot:[`item.BrandL2`]="{ item }"
        >
          <v-simple-checkbox
            v-model="item.BrandL2"
          />
        </template>
        <template
          v-slot:[`item.BrandL3`]="{ item }"
        >
          <v-simple-checkbox
            v-model="item.BrandL3"
          />
        </template>
        <!-- <template
          v-slot:[`item.LocalBrandGL`]="{ item }"
        >
          <v-simple-checkbox
            v-model="item.LocalBrandGL"
          />
        </template>
        <template
          v-slot:[`item.LocalBrandMaterial`]="{ item }"
        >
          <v-simple-checkbox
            v-model="item.LocalBrandMaterial"
          />
        </template> -->
        <!-- <template
          v-slot:[`item.Sales_Associate_L2`]="{ item }"
        >
          <v-simple-checkbox
            v-model="item.Sales_Associate_L2"
          />
        </template>
        <template
          v-slot:[`item.Sales_Associate_L3`]="{ item }"
        >
          <v-simple-checkbox
            v-model="item.Sales_Associate_L3"
          />
        </template>
        <template
          v-slot:[`item.Sales_Associate_L4`]="{ item }"
        >
          <v-simple-checkbox
            v-model="item.Sales_Associate_L4"
          />
        </template>
        <template
          v-slot:[`item.Sales_Associate_L5`]="{ item }"
        >
          <v-simple-checkbox
            v-model="item.Sales_Associate_L5"
          />
        </template>
        <template
          v-slot:[`item.Sales_Manager_L1`]="{ item }"
        >
          <v-simple-checkbox
            v-model="item.Sales_Manager_L1"
          />
        </template> -->
        <template
          v-slot:[`item.ClientCategory`]="{ item }"
        >
          <v-simple-checkbox
            v-model="item.ClientCategory"
          />
        </template>
        <template
          v-slot:[`item.SalesGroup`]="{ item }"
        >
          <v-simple-checkbox
            v-model="item.SalesGroup"
          />
        </template>
        <template
          v-slot:[`item.CSN`]="{ item }"
        >
          <v-simple-checkbox
            v-model="item.CSN"
          />
        </template>
        <template
          v-slot:[`item.ClientSegment`]="{ item }"
        >
          <v-simple-checkbox
            v-model="item.ClientSegment"
          />
        </template>
        <!-- <template
          v-slot:[`item.clientsegment_new`]="{ item }"
        >
          <v-simple-checkbox
            v-model="item.clientsegment_new"
          />
        </template> -->
        <template
          v-slot:[`item.ShortCycleDesc`]="{ item }"
        >
          <v-simple-checkbox
            v-model="item.ShortCycleDesc"
          />
        </template>
        <!-- <template
          v-slot:[`item.ProductLeadCL1_Client`]="{ item }"
        >
          <v-simple-checkbox
            v-model="item.ProductLeadCL1_Client"
          />
        </template>
        <template
          v-slot:[`item.ProductSpecialistCL2_Client`]="{ item }"
        >
          <v-simple-checkbox
            v-model="item.ProductSpecialistCL2_Client"
          />
        </template>
        <template
          v-slot:[`item.ProductSpecialistCL3_Client`]="{ item }"
        >
          <v-simple-checkbox
            v-model="item.ProductSpecialistCL3_Client"
          />
        </template>
        <template
          v-slot:[`item.ProductSpecialistCL4_Client`]="{ item }"
        >
          <v-simple-checkbox
            v-model="item.ProductSpecialistCL4_Client"
          />
        </template>
        <template
          v-slot:[`item.ProductSpecialistCL5_Client`]="{ item }"
        >
          <v-simple-checkbox
            v-model="item.ProductSpecialistCL5_Client"
          />
        </template> -->
        <!-- <template
          v-slot:[`item.ProductLeadCL1_GL`]="{ item }"
        >
          <v-simple-checkbox
            v-model="item.ProductLeadCL1_GL"
          />
        </template>
        <template
          v-slot:[`item.ProductSpecialistCL2_GL`]="{ item }"
        >
          <v-simple-checkbox
            v-model="item.ProductSpecialistCL2_GL"
          />
        </template>
        <template
          v-slot:[`item.ProductLeadCL1_Material`]="{ item }"
        >
          <v-simple-checkbox
            v-model="item.ProductLeadCL1_Material"
          />
        </template>
        <template
          v-slot:[`item.ProductSpecialistCL2_Material`]="{ item }"
        >
          <v-simple-checkbox
            v-model="item.ProductSpecialistCL2_Material"
          />
        </template> -->
        <!-- <template
          v-slot:[`item.TeamMember`]="{ item }"
        >
          <v-simple-checkbox
            v-model="item.TeamMember"
          />
        </template> -->
        <template
          v-slot:[`item.local_brand`]="{ item }"
        >
          <v-simple-checkbox
            v-model="item.local_brand"
          />
        </template>
        <template
          v-slot:[`item.local_brand_lv2`]="{ item }"
        >
          <v-simple-checkbox
            v-model="item.local_brand_lv2"
          />
        </template>
        <!-- <template
          v-slot:[`item.productleadcl1`]="{ item }"
        >
          <v-simple-checkbox
            v-model="item.productleadcl1"
          />
        </template>
        <template
          v-slot:[`item.productspecialistcl2`]="{ item }"
        >
          <v-simple-checkbox
            v-model="item.productspecialistcl2"
          />
        </template>
        <template
          v-slot:[`item.productspecialistcl3`]="{ item }"
        >
          <v-simple-checkbox
            v-model="item.productspecialistcl3"
          />
        </template>
        <template
          v-slot:[`item.productspecialistcl4`]="{ item }"
        >
          <v-simple-checkbox
            v-model="item.productspecialistcl4"
          />
        </template>
        <template
          v-slot:[`item.productspecialistcl5`]="{ item }"
        >
          <v-simple-checkbox
            v-model="item.productspecialistcl5"
          />
        </template> -->
        <template
          v-slot:[`item.hfm_client_name`]="{ item }"
        >
          <v-simple-checkbox
            v-model="item.hfm_client_name"
          />
        </template>
        <template
          v-for="(wo, wi) in walkColumns"
          v-slot:[`item.walkxx`+wi]="{ item, index }"
        >
          <div
            :key="'setting-walks-' + wi + '-' + index"
            style="min-width:180px"
          >
            <v-autocomplete
              v-if="item['walkxx' + wi]"
              v-model="item['walkxx' + wi].value"
              chips
              deletable-chips
              full-width
              multiple
              hide-details
              :items="item['walkxx' + wi].items"
            />
            <div class="grey--text text--lighten-1 text-caption mb-2">
              Please input and select
            </div>
          </div>
        </template>
      </v-data-table>
      <p />
      <v-row
        align="end"
        justify="end"
      >
        <div
          v-if="status.saving"
          class="mb-3 mr-5 grey--text"
        >
          Saving
        </div>
        <div
          v-else-if="status.save.text"
          :class="[
            'mb-3 mr-5',
            status.save.done ? 'success--text' : 'red--text',
          ]"
        >
          {{ status.save.text }}
        </div>
        <v-btn
          tile
          color="success"
          :loading="status.loading || status.saving"
          @click="openDialog"
        >
          Save
        </v-btn>
      </v-row>
    </base-material-card>
    <v-dialog
      :value="isUserSaving"
      persistent
      min-width="900px"
      max-width="900px"
    >
      <v-card>
        <v-card-title>
          <div style="width:100%;display:flex;vertical-align:center;">
            <div style="flex:1;text-align:left;font-weight:600;">
              WARNING: CHANGE SETTING WILL DELETE ALL SAVED DATA BEFORE!
              ARE YOU SURE TO CHANGE SETTING? (Will take 10s to reload data)
            </div>
          </div>
        </v-card-title>
        <v-card-actions class="pa-5 pt-3">
          <v-spacer />
          <v-btn
            color="primary"
            text
            @click="postSaveSetting"
          >
            Change
          </v-btn>
          <v-btn
            color="red"
            class="ma-0"
            @click="closeDialog"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import { mapState } from 'vuex'
  import { xPost } from '@/http/axios/index.js'
  export default {
    data () {
      return {
        myDom: {
          params: {},
        },
        search: '',
        currency: [
          { text: 'Local Currency', sortable: false, value: false },
          { text: 'USD', sortable: false, value: true }
        ],
        blocked: [
          { text: 'Include', sortable: false, value: false },
          { text: 'Exclude', sortable: false, value: true }
        ],
        status: {
          loading: false,
          saving: false,
          save: {
            done: false,
            text: ''
          }
        },
        columns: [
          {
            type: 'metric',
            header: { text: 'Country', align: 'start', sortable: false, value: 'ZoneL4' }
          },
          // {
          //   header: { text: 'Action', sortable: false, value: 'btn' }
          // },
          {
            type: 'checkbox',
            header: { text: 'Material Id', sortable: false, value: 'MaterialId' }
          },
          {
            type: 'checkbox',
            header: { text: 'Plan Detail', sortable: false, value: 'OATMaterial' }
          },
          {
            type: 'checkbox',
            header: { text: 'T&B/Cash', sortable: false, value: 'tb_cash' }
          },
          {
            type: 'checkbox',
            header: { text: 'Customer Id', sortable: false, value: 'CI' }
          },
          {
            type: 'checkbox',
            header: { text: 'GL Account', sortable: false, value: 'Account' }
          },
          {
            type: 'checkbox',
            header: { text: 'Currency', sortable: false, value: 'Currency' }
          },
          {
            type: 'checkbox',
            header: { text: 'Blocked', sortable: false, value: 'Blocked' }
          },
          {
            type: 'checkbox',
            header: { text: 'EPM Adj', sortable: false, value: 'EPM' }
          },
          {
            type: 'checkbox',
            header: { text: 'Brand L1', sortable: false, value: 'BrandL1' }
          },
          {
            type: 'checkbox',
            header: { text: 'Brand L2', sortable: false, value: 'BrandL2' }
          },
          {
            type: 'checkbox',
            header: { text: 'Brand L3', sortable: false, value: 'BrandL3' }
          },
          // {
          //   type: 'checkbox',
          //   header: { text: 'Local Brand - GL', sortable: false, value: 'LocalBrandGL' }
          // },
          // {
          //   type: 'checkbox',
          //   header: { text: 'Local Brand - Material', sortable: false, value: 'LocalBrandMaterial' }
          // },
          // {
          //   type: 'checkbox',
          //   header: { text: 'Sales Associate(L2)', sortable: false, value: 'Sales_Associate_L2' }
          // },
          // {
          //   type: 'checkbox',
          //   header: { text: 'Sales Associate L3', sortable: false, value: 'Sales_Associate_L3' }
          // },
          // {
          //   type: 'checkbox',
          //   header: { text: 'Sales Manager L1', sortable: false, value: 'Sales_Manager_L1' }
          // },
          {
            type: 'checkbox',
            header: { text: 'Client Category', sortable: false, value: 'ClientCategory' }
          },
          {
            type: 'checkbox',
            header: { text: 'Sales Group', sortable: false, value: 'SalesGroup' }
          },
          {
            type: 'checkbox',
            header: { text: 'Client Short Name', sortable: false, value: 'CSN' }
          },
          {
            type: 'checkbox',
            header: { text: 'Client Segment', sortable: false, value: 'ClientSegment' }
          },
          // {
          //   type: 'checkbox',
          //   header: { text: 'Client Segment New', sortable: false, value: 'clientsegment_new' }
          // },
          {
            type: 'checkbox',
            header: { text: 'Short Cycle', sortable: false, value: 'ShortCycleDesc' }
          },
          // {
          //   type: 'checkbox',
          //   header: { text: 'ProductLeadCL1 Client', sortable: false, value: 'ProductLeadCL1_Client' }
          // },
          // {
          //   type: 'checkbox',
          //   header: { text: 'ProductSpecialistCL2 Client', sortable: false, value: 'ProductSpecialistCL2_Client' }
          // },
          // {
          //   type: 'checkbox',
          //   header: { text: 'ProductLead L1 GL', sortable: false, value: 'ProductLeadCL1_GL' }
          // },
          // {
          //   type: 'checkbox',
          //   header: { text: 'ProductSpecialist L2 GL', sortable: false, value: 'ProductSpecialistCL2_GL' }
          // },
          // {
          //   type: 'checkbox',
          //   header: { text: 'ProductLead L1 Material', sortable: false, value: 'ProductLeadCL1_Material' }
          // },
          // {
          //   type: 'checkbox',
          //   header: { text: 'ProductSpecialist L2 Material', sortable: false, value: 'ProductSpecialistCL2_Material' }
          // },
          // {
          //   type: 'checkbox',
          //   header: { text: 'Team Member', sortable: false, value: 'TeamMember' }
          // },
          // {
          //   type: 'checkbox',
          //   header: { text: 'ProductSpecialistCL3 Client', sortable: false, value: 'ProductSpecialistCL3_Client' }
          // },
          // {
          //   type: 'checkbox',
          //   header: { text: 'ProductSpecialistCL4 Client', sortable: false, value: 'ProductSpecialistCL4_Client' }
          // },
          // {
          //   type: 'checkbox',
          //   header: { text: 'ProductSpecialistCL5 Client', sortable: false, value: 'ProductSpecialistCL5_Client' }
          // },
          // {
          //   type: 'checkbox',
          //   header: { text: 'Sales Associate L4', sortable: false, value: 'Sales_Associate_L4' }
          // },
          // {
          //   type: 'checkbox',
          //   header: { text: 'Sales Associate L5', sortable: false, value: 'Sales_Associate_L5' }
          // },
          {
            type: 'checkbox',
            header: { text: 'Local Brand', sortable: false, value: 'local_brand' }
          },
          {
            type: 'checkbox',
            header: { text: 'Local Brand LV2', sortable: false, value: 'local_brand_lv2' }
          },
          // {
          //   type: 'checkbox',
          //   header: { text: 'Productleadcl1', sortable: false, value: 'productleadcl1' }
          // },
          // {
          //   type: 'checkbox',
          //   header: { text: 'Productspecialistcl2', sortable: false, value: 'productspecialistcl2' }
          // },
          // {
          //   type: 'checkbox',
          //   header: { text: 'Productspecialistcl3', sortable: false, value: 'productspecialistcl3' }
          // },
          // {
          //   type: 'checkbox',
          //   header: { text: 'Productspecialistcl4', sortable: false, value: 'productspecialistcl4' }
          // },
          // {
          //   type: 'checkbox',
          //   header: { text: 'Productspecialistcl5', sortable: false, value: 'productspecialistcl5' }
          // },
          {
            type: 'checkbox',
            header: { text: 'HFM Client Name', sortable: false, value: 'hfm_client_name' }
          },
        ],
        walkColumns: [],
        config: {
          static: []
        },
        desserts: [],
        isUserSaving: false,
        dataOrigin: [],
      }
    },
    computed: {
      myModule () {
        return this.lodash.get(this.myDom, ['params', 'module']) || ''
      },
      myDB () {
        return this.lodash.get(this.myDom, ['params', 'db']) || ''
      },
      // settingDatabase () {
      //   if (this.myModule.toLowerCase() === 'setting') {
      //     this.db = 'international'
      //   } else if (this.myModule.toLowerCase() === 'ci-setting') {
      //     this.db = 'ci'
      //   } else if (this.myModule.toLowerCase() === 'bases-setting') {
      //     this.db = 'bases'
      //   }
      // },
      // # ms - delete gapi
      ...mapState(['user']),
      headers () {
        let ret = this.columns
          .filter(el => el.header)
          .map(el => ({
            value: el.value,
            ...el.header,
            static: this.config.static.includes(el.value),
            width: 100,
          }))
          .filter(el => !this.config.static.includes(el.value))
        return [
          ...ret,
          ...this.walkColumns
            .map((el, i) => ({
              value: 'walkxx' + i,
              text: el,
              sortable: false,
            }))
        ]
      },
    },
    beforeMount () {
      this.init()
    },
    methods: {
      async init () {
        this.myDom.params = this.$route.meta instanceof Object ? this.$route.meta : {}
        this.$eventBus.$emit('check-access')
        // if (this.myModule.toLowerCase() === 'setting') {
        //   this.db = 'international'
        // } else if (this.myModule.toLowerCase() === 'ci-setting') {
        //   this.db = 'ci'
        // } else if (this.myModule.toLowerCase() === 'bases-setting') {
        //   this.db = 'bases'
        // }
        // # ms - delete complete_check_access
        await this.postGetData()
      },
      async postGetData () {
        const params = {
          userinfo: this.user,
          db: this.myDB,
        }
        // console.log(this.db)
        this.status.loading = true
        try {
          const getSettings =
            xPost(
              'setting',
              'settings',
              params
            )
          const getWalks =
            xPost(
              'walk',
              'children',
              {
                db: this.myDB,
              }
            )
          const resSettings = await getSettings
          const resWalks = await getWalks
          if (
            !(resSettings.status === 200 && resSettings.data.settings instanceof Array) ||
            !(resWalks.status === 200 && resWalks.data.walks instanceof Array)
          ) {
            throw ''
          }
          if (resSettings.data.settingConfig instanceof Array) {
            this.config.static =
              resSettings.data.settingConfig
                .filter(el => el instanceof Object && +el.static)
                .map(el => el.key)
          }
          this.walkColumns.splice(0, this.walkColumns.length)
          this.desserts = resSettings.data.settings.map(el => {
            const ret = {}
            for (const key in el) {
              const index = this.columns.findIndex(el2 => el2.header.value === key)
              if (index !== -1) {
                switch (this.columns[index].type) {
                  case 'checkbox':
                    ret[key] =
                      !!parseInt(el[key])
                    break

                  default:
                    ret[key] = el[key]
                    break
                }
              }
            }
            const walks = (resWalks.data.walks || []).filter(el2 => el2.country === el.ZoneL4)
            const walkEle = {}
            for (const walk of walks) {
              if (!walk.name || !walk.parent) { continue }
              let wi = this.walkColumns.indexOf(walk.parent)
              if (wi === -1) {
                wi = this.walkColumns.length
                this.walkColumns.push(walk.parent)
              }
              const wkey = 'walkxx' + wi
              if (!walkEle[wkey]) {
                walkEle[wkey] = {
                  items: [],
                  value: [],
                  origin: [],
                }
              }
              walkEle[wkey].items.push(walk.name)
              if (+walk.used) {
                walkEle[wkey].value.push(walk.name)
                walkEle[wkey].origin.push(walk.name)
              }
            }
            return {
              ...ret,
              ...walkEle
            }
          })
          // console.log(this.desserts)
          // give value to dataOrigin
          this.dataOrigin = JSON.parse(JSON.stringify(this.desserts))
        } catch (err) {
          console.log("can't get setting data: ")
          console.log(err)
        }
        this.status.loading = false
      },
      // whether setting changed and set the param as the setting changed
      saveDataparam () {
        const ret = []
        const walk = []
        for (const index in this.desserts) {
          const item = this.desserts[index]
          let diffc = false
          let diffm = false
          for (const column of this.columns) {
            if (column.type === 'metric') { continue }
            const key = column.header.value
            if (column.type === 'checkbox') {
              diffc = (this.dataOrigin[index][key] !== this.desserts[index][key])
            }
            // if (column.type === 'multiple') {
            //   if (this.dataOrigin[index][key].length !== this.desserts[index][key].length) {
            //     diffm = true
            //   } else {
            //     const s = [...new Set([...this.dataOrigin[index][key], ...this.desserts[index][key]])]
            //     diffm = (this.dataOrigin[index][key].length !== s.length)
            //   }
            // }
            if (diffc || diffm) {
              break
            }
          }
          if (diffc || diffm) {
            ret.push(this.desserts[index])
          }
          for (let wi = 0; wi < this.walkColumns.length; wi++) {
            if (
              item['walkxx' + wi] &&
              (
                item['walkxx' + wi].value.find(el => !item['walkxx' + wi].origin.includes(el)) ||
                item['walkxx' + wi].origin.find(el => !item['walkxx' + wi].value.includes(el))
              )
            ) {
              walk.push({
                country: item.ZoneL4,
                parent: this.walkColumns[wi],
                value: item['walkxx' + wi].value,
              })
            }
          }
        }
        return {
          data: ret,
          walk: walk,
        }
      },
      async postSaveSetting () {
        const data = this.saveDataparam()
        if (!(data.data.length || data.walk.length)) {
          this.status.save.done = false
          this.status.save.text = 'No difference found.'
          this.isUserSaving = false
          return
        }
        this.status.saving = true
        try {
          const reqSettings =
            !data.data.length ||
            xPost(
              'setting',
              'save',
              {
                data: data.data,
                userinfo: this.user,
                db: this.myDB,
              }
            )
          const reqWalks =
            !data.walk.length ||
            xPost(
              'walk',
              'set_child',
              {
                data: data.walk,
                db: this.myDB,
              }
            )
          const resSettings = await reqSettings
          const resWalks = await reqWalks
          if (
            (!data.data.length || (resSettings.status === 200 && resSettings.data.done)) &&
            (!data.walk.length || (resWalks.status === 200 && resWalks.data.done))
          ) {
            this.status.save.done = true
            this.status.save.text = 'Saved.'
            await this.postGetData()
          } else {
            this.status.save.done = false
            this.status.save.text = 'Fail to Save.'
          }
        } catch (err) {
          console.log("can't get setting data: ")
          console.log(err)
        }
        this.status.saving = false
        this.isUserSaving = false
      },
      openDialog () {
        this.isUserSaving = true
      },
      closeDialog () {
        this.isUserSaving = false
      }
    }
  }
</script>
